import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_PURCHASEORDERS } from "../../../../utils/constants";
import { PurchaseOrderInterface } from "../../../../models/ProcurementModule/PurchateOrder/PurchaseOrder";
import purchaseOrderService from "../../../../services/procurementService/purchaseOrderService";

const usePurchaseOrderById = (id: string | undefined) =>
  useQuery<PurchaseOrderInterface, Error>({
    queryKey: [`${CACHE_KEY_PURCHASEORDERS}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, purchaseOrderId] = queryKey;
      return purchaseOrderService.GetById(purchaseOrderId as string);
    },
    enabled: !!id,
  });

export default usePurchaseOrderById;
